import { createAuthClient, adminClient } from '@cartcloser/auth/client';

/** Browser-side Better Auth client. Absolute baseURL is required. */
export const authClient = createAuthClient({
  baseURL: `${window.location.origin}/api/auth`,
  plugins: [adminClient()],
});
